// Mirror of src/libs/hismith/hismithLink.ts (www cannot import from the server tree).
// Keep the two in sync.

const TOKEN_PATTERN = /^[A-Za-z0-9]{4,32}$/;
const PATH_PREFIX = '/rplay';
/** `rplay<TOKEN>` or `rplay/<TOKEN>` pasted without the host. */
const BARE_PATH_PATTERN = /^rplay\/?([A-Za-z0-9]{4,32})$/;

export function parseRemotePlayLink(input: string): string | null {
    const trimmed = (input ?? '').trim();

    if (!trimmed) {
        return null;
    }

    // Checked before the bare-token test: `rplayABCD` is itself alphanumeric and would pass as a token.
    const barePath = BARE_PATH_PATTERN.exec(trimmed);

    if (barePath) {
        return barePath[1];
    }

    if (TOKEN_PATTERN.test(trimmed)) {
        return trimmed;
    }

    let url: URL;

    try {
        url = new URL(trimmed);
    } catch {
        return null;
    }

    if (!url.pathname.startsWith(PATH_PREFIX)) {
        return null;
    }

    const token = url.pathname.slice(PATH_PREFIX.length).replace(/^\/+/, '').replace(/\/+$/, '');

    return TOKEN_PATTERN.test(token) ? token : null;
}
